/**
 * AccessDenied - Pagina de error 403
 * Se muestra cuando el usuario no tiene permisos para acceder
 */
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Button from '@/components/ui/Button';
import Icon from '@/components/AppIcon';

const AccessDenied = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userProfile } = useAuth();

  const message =
    location.state?.message ||
    'No tienes permisos para acceder a esta seccion.';
  const fromPath = location.state?.from || null;

  const handleGoBack = () => {
    if (window.history.length > 2) {
      window.history.back();
    } else {
      navigate('/dashboard');
    }
  };

  const handleGoHome = () => {
    // Redirigir segun rol
    switch (userProfile?.role) {
      case 'superadmin':
      case 'admin':
        navigate('/admin/finanzas');
        break;
      case 'supervisor':
        navigate('/supervisor/portal');
        break;
      default:
        navigate('/dashboard');
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-red-50 to-orange-50 p-4">
      <div className="text-center max-w-md bg-white rounded-xl shadow-lg p-8">
        {/* Icono */}
        <div className="flex justify-center mb-6">
          <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center">
            <Icon name="ShieldX" className="w-12 h-12 text-red-500" />
          </div>
        </div>

        {/* Codigo de error */}
        <div className="mb-4">
          <span className="text-6xl font-bold text-red-500">403</span>
        </div>

        {/* Titulo */}
        <h1 className="section-title text-gray-800 mb-2">Acceso Denegado</h1>

        {/* Mensaje */}
        <p className="text-gray-600 mb-6">{message}</p>

        {/* Info de rol actual */}
        {userProfile?.role && (
          <div className="mb-6 p-3 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-500">
              Tu rol actual:{' '}
              <span className="font-medium text-gray-700 capitalize">
                {userProfile.role}
              </span>
            </p>
          </div>
        )}

        {/* Ruta intentada */}
        {fromPath && (
          <div className="mb-6 p-3 bg-orange-50 rounded-lg">
            <p className="text-sm text-orange-600">
              Ruta solicitada: <code className="font-mono">{fromPath}</code>
            </p>
          </div>
        )}

        {/* Botones */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={handleGoBack}
            className="flex items-center justify-center gap-2"
          >
            <Icon name="ArrowLeft" className="w-4 h-4" />
            Regresar
          </Button>

          <Button
            variant="default"
            onClick={handleGoHome}
            className="flex items-center justify-center gap-2"
          >
            <Icon name="Home" className="w-4 h-4" />
            Ir al Inicio
          </Button>
        </div>

        {/* Ayuda */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Si crees que deberias tener acceso, contacta al administrador del
            sistema.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
